import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { PiniaColada } from '@pinia/colada';
import App from './App.vue';
import router from './router';
import { setUnauthenticatedHandler } from './api/client';
import { useAuthStore } from './stores/auth';
import { useRealtime } from './composables/useRealtime';
import { installModuleRecovery } from './lib/module-recovery';
import './style.css';

const app = createApp(App);

app.use(createPinia());
app.use(PiniaColada, {});
installModuleRecovery(router);
app.use(router);

// Сессия истекла посреди работы — уводим на вход, не показывая
// пользователю каскад из ошибок «недостаточно прав»
setUnauthenticatedHandler(() => {
  // До навигации: иначе guard считает сессию живой и возвращает login → grid.
  useAuthStore().clearSession();
  useRealtime().stop(true);
  if (router.currentRoute.value.name !== 'login') {
    void router.replace({ name: 'login' });
  }
});

app.mount('#app');
